<template>
  <div>
    <el-button
      class="export-btn"
      type="primary"
      :disabled="isDjus"
      @click="exportExcel()"
    >导出Excel</el-button>
    <!-- 弹出导出框 -->
    <el-dialog
      append-to-body
      title="选择您要导出的条目"
      :visible.sync="dialogShowType"
      @closed="closeDialog"
    >
      <el-form ref="reportForm" :model="reportForm">
        <el-form-item prop="checkboxGroup">
          <div style="margin: 0px 0px 15px 10px">
            <el-checkbox
              v-model="checkAll"
              :indeterminate="isIndeterminate"
              @change="handleCheckAllChange"
            >全选</el-checkbox>
          </div>
          <el-checkbox-group
            v-model="reportForm.checkboxGroup"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox
              v-for="item in formDataList"
              id="export-info"
              :key="item.cn"
              :label="item"
              class="checkbox-button-export-border"
              border
            >{{ item.cn }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          align="center"
          style="color: #c0c4cc"
        >提示:直接点击确定导出全部已搜索数据</el-form-item>
        <el-form-item align="center">
          <el-button
            class="calcesBtn"
            @click="dialogShowType = false"
          >取消</el-button>
          <el-button
            type="primary"
            class="suresBtn"
            :loading="buttonLoading"
            @click="formOut()"
          >确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/*global http protocol*/

export default {
  components: {},
  // @ tableRef 需要导出的el-table的 ref对象  例如  this.$refs.tableData
  // protocolName 导出使用的接口 例如 param_exportQueryFuAccountFundsFlow
  // searchForm 已启用的搜索条件  例如 searchForm:{}
  // fileName 导出的文件名称  例如 资金流水.xls
  props: {
    tableRef: {
      type: Object,
      default: function() {
        return {}
      }
    },
    protocolName: {
      type: String,
      default: ''
    },
    searchForm: {
      type: Object,
      default: function() {
        return {}
      }
    },
    fileName: {
      type: String,
      default: '导出表格.xls'
    },
    isDjus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 导出用容器
      reportForm: {
        checkboxGroup: []
      },
      // 导出用 cn 与en字段名称
      formDataList: [], // tabel传过来的初始数据
      dialogShowType: false,
      buttonLoading: false,
      isIndeterminate: false,
      checkAll: false
    }
  },
  computed: {
    formDataListCnName: function() {
      const tmp = []
      this.formDataList.forEach((element) => {
        tmp.push(element.cn)
      })
      return tmp
    }
  },
  mounted() {

  },
  methods: {
    // 获取数据打开窗口
    exportExcel() {
      const temData = []
      // 遍历table所有的列名称 如果是 序号 空字符串  或者是操作按钮 就会过滤
      for (const item in this.tableRef.columns) {
        if (this.tableRef.columns[item].type === 'index') {
          continue
        }
        if (this.tableRef.columns[item].type === 'selection') {
          continue
        }
        if (this.tableRef.columns[item].type === 'expand') {
          continue
        }
        if (this.tableRef.columns[item].className === 'exportExcept') {
          continue
        }
        const data = {
          cn: this.tableRef.columns[item].label,
          en: this.tableRef.columns[item].property
        }
        temData.push(data)
      }
      // 将searchForm所有的数值赋值给接口
      for (const item in this.searchForm) {
        protocol[this.protocolName].param[item] = this.searchForm[item]
      }
      this.formDataList = temData
      this.reportForm.checkboxGroup = this.formDataList
      this.isIndeterminate = false
      this.checkAll = true
      this.dialogShowType = true
    },
    handleCheckAllChange(val) {
      this.reportForm.checkboxGroup = val ? this.formDataList : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.formDataList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.formDataList.length
    },
    // 导出请求
    formOut(formName) {
      let cn = ''
      let en = ''
      if (this.reportForm.checkboxGroup.length === 0) {
        // for (var i = 0; i < this.formDataList.length; i++) {
        //   cn = cn + this.formDataList[i].cn + ','
        //   en = en + this.formDataList[i].en + ','
        // }
        this.$message({
          type: 'warning',
          message: '请至少选择一列'
        })
        return
      } else {
        this.buttonLoading = true
        for (var k = 0; k < this.reportForm.checkboxGroup.length; k++) {
          cn = cn + this.reportForm.checkboxGroup[k].cn + ','
          en = en + this.reportForm.checkboxGroup[k].en + ','
        }
      }
      cn = cn.substring(0, cn.length - 1)
      en = en.substring(0, en.length - 1)
      protocol[this.protocolName].param.cn = cn
      protocol[this.protocolName].param.en = en
      http.postReport(protocol[this.protocolName]).then((res) => {
        // const blob = res.data
        // const reader = new FileReader()
        // reader.readAsDataURL(blob)
        // reader.onload = e => {
        //   const a = document.createElement('a')
        //   a.download = this.fileName
        //   a.href = e.target.result
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //   this.dialogShowType = false
        // }
        var blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.href = href
        downloadElement.download = this.fileName // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
        this.dialogShowType = false
      })
    },
    // 关闭窗口重置数据
    closeDialog() {
      this.dialogShowType = false
      this.buttonLoading = false
      // this.$refs.reportForm.resetFields()
    }
  }
}
</script>

<style scoped lang="scss">
.export-btn {
  /* margin: 0px 5px; */
  margin-left: 10px;
  height: 32px;
  background: #2b63a9;
  border-color: #2b63a9;
  padding: 0 15px;
}
/deep/.el-checkbox-group .el-checkbox{
  width:142px;
  text-align: center;
}
/deep/.el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left:0;
}
</style>
